import type {ExtractPropsWithoutRef} from '@/types';

import {BackToTop} from '@travel-frontend/ui-components';
import {forwardRef, memo} from 'react';
import {useTranslation} from 'react-i18next';

import {config} from '@/config';
import {styles} from '@/modules/common/components/BackToTopButton/styles';
import {sharedTestId} from '@/utils/testId';

const BackToTopButtonComponent = forwardRef<
  HTMLButtonElement,
  ExtractPropsWithoutRef<typeof BackToTop>
>(function BackToTopButtonComponent(props, ref) {
  const {t} = useTranslation('general');

  return (
    <BackToTop
      {...props}
      // @ts-expect-error TS2322: This is a styled component
      css={config.liveChat.enabled ? styles.default : undefined}
      ref={ref}
      data-testid={sharedTestId('backToTopButton')}
    >
      {t('buttons.backToTop')}
    </BackToTop>
  );
});

export const BackToTopButton = memo(BackToTopButtonComponent);
